import {
    makeStyles,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    TablePagination,
    Grid,
    Typography,
    CircularProgress,
} from "@material-ui/core";
import React, { useState, useEffect } from "react";

const useStyles = makeStyles({
    root: {},
    emptyCell: {
        borderBottom: "none",
    },
    emptyRow: {
        height: "14rem",
    },
    planSelect: {
        width: "9rem",
    },
    selectGrid: {
        paddingBottom: "1rem",
    },
    selectLabel: {
        paddingRight: "1rem",
    },
});

const PlanWiseSecurities = ({
    plan,
    setPlan,
    isFilteredStreamSubscribed,
    cryptoStreamData,
    stocksStreamData,
    isStreamAppStarted,
}) => {
    const classes = useStyles();

    const columns = [
        { id: "SummarizationItemId", label: "Summarization Item Id" },
        { id: "SecurityName", label: "Security Name" },
        {
            id: "PositiveSentimentVerified",
            label: "Positive Sentiment Verified",
        },
        {
            id: "NegativeSentimentVerified",
            label: "Negative Sentiment Verified",
        },
        {
            id: "NeutralSentimentVerified",
            label: "Neutral Sentiment Verified",
        },
    ];

    const [securitySentimentByPlan, setSecuritySentimentByPlan] = useState([]);
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(5);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const handleChange = (event) => {
        setPlan(event.target.value);
    };

    useEffect(() => {
        if (plan === "crypto") {
            setSecuritySentimentByPlan(() => [...cryptoStreamData]);
        } else if (plan === "stock") {
            setSecuritySentimentByPlan(() => [...stocksStreamData]);
        }
    }, [plan, cryptoStreamData, stocksStreamData]);

    const emptyRows =
        securitySentimentByPlan &&
        securitySentimentByPlan.length &&
        rowsPerPage - Math.min(rowsPerPage, securitySentimentByPlan.length - page * rowsPerPage);

    return (
        <div className={classes.root}>
            <Grid container alignItems="center" className={classes.selectGrid}>
                <Grid item>
                    <Typography className={classes.selectLabel} variant="subtitle2">
                        Plan:
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Select
                        className={classes.planSelect}
                        variant="outlined"
                        value={plan}
                        onChange={handleChange}
                        disabled={isFilteredStreamSubscribed}
                    >
                        <MenuItem value={"stock"}>Stock</MenuItem>
                        <MenuItem value={"crypto"}>Crypto</MenuItem>
                    </Select>
                </Grid>
            </Grid>
            <Paper>
                <TableContainer>
                    <Table stickyHeader>
                        <TableHead>
                            <TableRow>
                                {columns.map((column) => (
                                    <TableCell key={column.id} align="center">
                                        {column.label}
                                    </TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {securitySentimentByPlan && securitySentimentByPlan.length ? (
                                securitySentimentByPlan
                                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                    .map((security, index) => {
                                        return (
                                            <TableRow hover role="checkbox" tabIndex={-1} key={index}>
                                                <TableCell align="center">{security.SummarizationItemId}</TableCell>
                                                <TableCell align="center">{security.SecurityName}</TableCell>
                                                <TableCell align="center">
                                                    {security.PositiveSentimentVerified}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {security.NegativeSentimentVerified}
                                                </TableCell>
                                                <TableCell align="center">
                                                    {security.NeutralSentimentVerified}
                                                </TableCell>
                                            </TableRow>
                                        );
                                    })
                            ) : (
                                <TableRow className={classes.emptyRow}>
                                    <TableCell className={classes.emptyCell} />
                                    <TableCell className={classes.emptyCell} />
                                    <TableCell align="center" component="th" className={classes.emptyCell}>
                                        {!isStreamAppStarted ? <></> : <CircularProgress size={30} />}
                                    </TableCell>
                                    <TableCell className={classes.emptyCell} />
                                    <TableCell className={classes.emptyCell} />
                                </TableRow>
                            )}
                            {emptyRows > 0 && (
                                <TableRow style={{ height: `${2.8 * emptyRows}rem` }}>
                                    <TableCell colSpan={6} />
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5]}
                    component="div"
                    count={securitySentimentByPlan && securitySentimentByPlan.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onChangePage={handleChangePage}
                    onChangeRowsPerPage={handleChangeRowsPerPage}
                />
            </Paper>
        </div>
    );
};

export default PlanWiseSecurities;
